
export const LimitAPIBankCore : number = 2000;